import "./index.css";
import { hideSpinner, showSpinner } from "../utils";

export default class LicenseAgreementWizard {
    /**
     * @type {HTMLElement | null | undefined}
     */
    #loadingSpinnerContainer;

    /** Callback to invoke after agreement signed after basic login. */
    #successCallback;

    /** Success callback to invoke after license successfully signed after external auth login. */
    #externalAuthSuccessCallback;
    /**
     *
     * @param {(event: SubmitEvent?, signLicenseAgreement: boolean) => void} successCallback
     * @param {(...args: *[]) => void} externalAuthSuccessCallback
     */
    constructor(
        successCallback,
        externalAuthSuccessCallback
    ) {
        this.#successCallback = successCallback;
        this.#externalAuthSuccessCallback = externalAuthSuccessCallback;
    }

    async initialize() {
        $(document)
            .on(
                "click",
                ".agreementCheckbox",
                this.#onAgreementCheck.bind(this),
            )
            .on("click", ".closeDialog", this.#closeDialog.bind(this))
            .on(
                "click",
                "#signLicenseAgreement",
                this.#signLicenseAgreement.bind(this),
            )
            .on("keydown", (e) => {
                // PBI 34953: Closing the license popup with the ESC key and reopening it causes the popup to break
                // Although calling #closeDialog on ESC would resolve this,
                // the decision was made not to allow ESC to close the popup.
                if (e.key === "Escape" || e.keyCode === 27) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            });
        await this.#licenseAgreementRegistration();
    }

    /**
     * License registration entry method.
     * Replaces Div with a kendo window for license key transaction.
     */
    async #licenseAgreementRegistration() {
        const { promise: getEulaView, resolve, reject } = Promise.withResolvers();
        const url = BINamespace.getPathUrl() + "/Proxyless/PopupLicenseAgreement";
        $.ajax({
            url: url,
            type: "POST",
            contentType: "application/json; charset=utf-8",
            global: false,
            cache: false,
            success: resolve,
            error: reject,
        });
        const view = await getEulaView;
        const dialogElement = document.createElement("dialog");
        dialogElement.id = "licenseAgreementWizard";
        dialogElement.innerHTML = view;

        // Prepend instead of append because the Bitwarden extension messes up the dialog if it's the last element in its container.
        $(document.body).prepend(dialogElement);
        dialogElement.showModal();
        this.#loadingSpinnerContainer = document.getElementById(
            "licenseAgreementContainer",
        );
    }

    /**
     * Enable finish button.
     * @param {JQuery.ClickEvent} e
     */
    #onAgreementCheck(e) {
        if (e.target?.checked) {
            $("#signLicenseAgreement")
                .prop("disabled", false)
                .removeClass("disabled");
        } else {
            $("#signLicenseAgreement")
                .prop("disabled", true)
                .addClass("disabled");
        }
    }

    /**
     * Closes window and login on registration.
     */
    #signLicenseAgreement() {
        this.#showSpinner();
        // @ts-expect-error
        if (!BINamespace.authData) {
            this.#successCallback(null, true);
        } else {
            // @ts-expect-error
            const authData = BINamespace.parseJsonString(BINamespace.authData);
            $.ajax({
                url:
                    BINamespace.getPathUrl() +
                    "/Account/ConnectFromExternalAccount",
                data: JSON.stringify({
                    CP: authData.centralPoint,
                    FlowId: authData.flowId,
                    CentralPointHash: authData.centralPoint,
                    Lang: authData.language,
                    UserName: authData.username,
                    IsIframe: authData.isIframe,
                    SignalRId: authData.signalRId,
                    ProviderId: authData.providerId,
                    ProviderType: authData.providerType,
                    IsRefreshed: authData.isRefreshed,
                    ReturnUrl: authData.returnUrl,
                    IsCalledByLogin: true,
                    ForceMobileMode: authData.forceMobileMode,
                    SignLicenseAgreement: true,
                }),
                type: "POST",
                contentType: "application/json; charset=utf-8",
                success: (data) => this.#externalAuthSuccessCallback(data),
            });
        }
        this.#closeDialog();
        this.#hideSpinner();
    }

    #showSpinner() {
        showSpinner(this.#loadingSpinnerContainer);
    }

    #hideSpinner() {
        hideSpinner(this.#loadingSpinnerContainer);
    }

    /**
     * Cancels registration process and closes the dialog.
     */
    #closeDialog() {
        this.#destroy();

        const dialogElement = document.getElementById("licenseAgreementWizard");

        if (dialogElement instanceof HTMLDialogElement) {
            dialogElement.close();
            dialogElement.remove();
        }
    }

    #destroy() {
        $(document)
            .off("click", "#signLicenseAgreement")
            .off("click", ".closeDialog")
            .off("click", ".agreementCheckbox")
            .off("keydown");
    }
}